import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import { type FC, useCallback } from 'react'
import { useIntl } from 'react-intl'

import {
  ProductSearchRefinementCheckbox,
  type ProductSearchRefinementCheckboxProps,
} from '../ProductSearchRefinementCheckbox'

const supportedPrescriptionTypesLabels = new Set(['false', 'true'])

const transformItems = (
  items: RefinementListItem[],
  intl: ReturnType<typeof useIntl>,
): RefinementListItem[] => {
  const labels = new Set(items.map((item) => item.label))

  // Check Algolia items have provided supported labels
  if (labels.symmetricDifference(supportedPrescriptionTypesLabels).size > 0) {
    return []
  }

  return items.map((item) => ({
    ...item,
    label:
      item.label === 'true'
        ? intl.formatMessage({
            id: 'prescription.labels.prescriptionRequired',
          })
        : intl.formatMessage({
            id: 'prescription.labels.noPrescriptionRequired',
          }),
  }))
}

type ProductSearchRefinementPrescriptionTypesProps = Omit<
  ProductSearchRefinementCheckboxProps,
  'transformItems'
>

export const ProductSearchRefinementPrescriptionTypes: FC<
  ProductSearchRefinementPrescriptionTypesProps
> = (props) => {
  const intl = useIntl()

  const memoizedTransformItems = useCallback(
    (refinementListItems: RefinementListItem[]) =>
      transformItems(refinementListItems, intl),
    [intl],
  )

  return (
    <ProductSearchRefinementCheckbox
      {...props}
      transformItems={memoizedTransformItems}
    />
  )
}
